module.exports = __webpack_public_path__ + "static/media/logo.21536db8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/GettingStarted/logo.svg
// module id = 6898
// module chunks = 0